export const environmentBaseProd = {
  production: true,
  auth: {
    domain: 'auth.legalresources.com',
    // Must match the Auth0 API Identifier exactly (usually full URL)
    audience: 'https://api.legalresources.com',
    redirectUri: window.location.origin + '/callback',
    cacheLocation: 'localstorage' as const,
    useRefreshTokens: true,
    connection: 'email' // Passwordless email authentication
  },
  apiUrl: 'https://api.legalresources.com/v1',
  enrollmentBaseUrl: 'https://enrollment.legalresources.com'
};
